import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark' | 'system';

type ThemeState = {
  theme: Theme;
  setTheme: (theme: Theme) => void;
  apply: () => void;
};

function resolve(theme: Theme): 'light' | 'dark' {
  if (theme === 'system') {
    return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
  }
  return theme;
}

export const useThemeStore = create<ThemeState>()(
  persist(
    (set, get) => ({
      theme: 'system',
      setTheme: (theme) => {
        set({ theme });
        const root = document.documentElement;
        root.classList.toggle('dark', resolve(theme) === 'dark');
      },
      apply: () => {
        const root = document.documentElement;
        root.classList.toggle('dark', resolve(get().theme) === 'dark');
      },
    }),
    { name: 'minishop-theme' },
  ),
);

if (typeof window !== 'undefined') {
  window
    .matchMedia('(prefers-color-scheme: dark)')
    .addEventListener('change', () => {
      const { theme, apply } = useThemeStore.getState();
      if (theme === 'system') apply();
    });
}
